import { render, staticRenderFns } from "./OptionCreatePricingView.vue?vue&type=template&id=4880ebea&scoped=true&"
import script from "./OptionCreatePricingView.vue?vue&type=script&lang=ts&"
export * from "./OptionCreatePricingView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4880ebea",
  null
  
)

export default component.exports